<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-18 15:31:31
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-29 11:38:06
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/search/selectedTag.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEc
-->
<template>
	<div class="selectd-tag">
		<div v-if="exhibition">
			<div class="line mt-16 mb-16"></div>
			<div class="select-form">
				<div class="form-lable fz-12 mr-16">已选:</div>
				<div class="flex flex-just-between flex-1">
					<div class="content flex flex-wrap mr-8">
						<div v-for="(tag, index) in tagList" :key="index">
							<el-tag
								@close="
									() => {
										onClose({}, 0);
									}
								"
								v-if="tag.type === 'search' && tag.item.length"
								:key="tag.name"
								class="flex mr-8 mb-5 el-tag"
								closable
								effect="plain"
								color="#fff"
								disable-transitions
								>{{ tag.name }}：{{ tag.item  | textFormat(30) }}</el-tag
							>
							<el-tag
								@close="
									() => {
										onClose({}, 1);
									}
								"
								class="flex mr-8 mb-6 el-tag"
								v-if="tag.type === 'category' && tag.item.length"
								:key="tag.name"
								closable
								effect="plain"
								color="#fff"
								disable-transitions
							>
								{{ tag.name }}：<span>{{ categoryContent | textFormat(30) }}</span>
							</el-tag>
							<div class="flex" v-if="tag.type === 'shipment' && tag.item.length">
								<div v-for="ship in tag.item" :key="ship.name">
									<el-tag
										@close="
											() => {
												onClose(ship, 2);
											}
										"
										v-if="ship.value"
										class="flex mr-8 mb-5 el-tag"
										closable
										effect="plain"
										color="#fff"
										disable-transitions
										>  {{ ship.name }}： {{ ['auditStatus','commissionType','appType'].includes(ship.key)? ship.label : ship.value }}</el-tag
									>
								</div>
							</div>
						</div>
					</div>
					<div class="clear-text fz-12 pointer" @click="onClear()">清空选项</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			tagList: [],
		};
	},
	computed: {
		categoryContent() {
			return this.tagList[1].item.map(val => val.category_name).join('、');
		},
		exhibition() {
			let show = false;
			this.tagList.map((val)=>{
				if(val.item.length && ['search','category'].includes(val.type)){
					show = true;
				}
				if(val.type === 'shipment'){
					val.item.map(v=>{
						if(v.value){
							show = true;
						}
					})
				}
			})
			return show;
		},
	},
	methods: {
		show(list) {
			this.tagList = list;
		},
		onClose(item, type) {
			this.$emit('change', { item, type });
		},
		onClear(){
			this.$emit('clear')
		}
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-tag--plain {
	color: @color-gy8;
	border-color: @color-gy4;
}
/deep/ .el-tag--plain .el-tag__close {
	color: @color-gy7;
}
.line {
	width: 100%;
	height: 1px;
	background: @color-gy3;
}
.select-form {
	display: flex;
	justify-content: space-between;
	.form-lable {  
		min-width: 36px;
		height: 20px;
		color: @color-gy7;
		display: flex;
		align-items: center;
	}
	.clear-text {
		min-width: 50px;
		height: 20px;
		color: @color-p;
	}
}
.el-tag{
	/deep/ .el-tag__close:hover{
		background-color: transparent !important
	}
}
</style>
